import { render, staticRenderFns } from "./VisaoAnalitica.vue?vue&type=template&id=2bbf6538"
import script from "./VisaoAnalitica.vue?vue&type=script&lang=js"
export * from "./VisaoAnalitica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports